if (!customElements.get('frame-model-options')) {
  customElements.define('frame-model-options', class extends HTMLElement {
    connectedCallback() {
      this.picker = this.closest('variant-selects');
      this.variants = JSON.parse(this.querySelector('[data-canvas-variants]').textContent);
      this.options = JSON.parse(this.querySelector('[data-canvas-options]').textContent);
      this.images = JSON.parse(this.querySelector('[data-frame-model-images]')?.textContent || '{}');
      this.selected = JSON.parse(this.picker.querySelector('[data-selected-variant]').textContent);
      if (!this.selected) this.selected = this.variants.find(v => v.available) || this.variants[0];
      this.frameIndex = this.options.findIndex(o => ['Çerçeve', 'Çerçeve Rengi'].includes(o.name));
      this.sizeIndex = this.options.findIndex(o => o.name === 'Ölçü');
      this.styleIndex = this.options.findIndex(o => o.name === 'Baskı Stili');
      if (this.frameIndex < 0 || this.sizeIndex < 0 || !this.selected) return;
      this.addEventListener('click', e => this.choose(e));
      this.render();
      this.hidden = false;
    }
    model(v) {
      const frame = v.options[this.frameIndex];
      if (frame.endsWith(' L (Kanvas)')) return 'canvas';
      if (frame.endsWith(' Derin')) return 'deep';
      if (frame === 'Galeri') return 'gallery';
      return 'standard';
    }
    color(v) {
      const frame = v.options[this.frameIndex];
      return frame === 'Galeri' ? 'Siyah' : frame.replace(/ (?:Derin|L \(Kanvas\))$/, '');
    }
    money(cents) {
      return new Intl.NumberFormat('tr-TR', {style:'currency', currency:'TRY', maximumFractionDigits:0}).format(cents / 100);
    }
    target(field, value) {
      const current = this.selected;
      const model = field === 'model' ? value : this.model(current);
      let candidates = this.variants.filter(v => this.model(v) === model);
      if (field === 'color') candidates = candidates.filter(v => this.color(v) === value && v.options[this.sizeIndex] === current.options[this.sizeIndex]);
      if (field === 'size') candidates = candidates.filter(v => v.options[this.sizeIndex] === value && this.color(v) === this.color(current));
      if (field === 'style') candidates = candidates.filter(v => v.options[this.styleIndex] === value && v.options[this.sizeIndex] === current.options[this.sizeIndex] && this.color(v) === this.color(current));
      const score = v => {
        let n = v.available ? 100 : 0;
        this.options.forEach((o,i) => { if (v.options[i] === current.options[i]) n += i === this.sizeIndex ? 20 : 4; });
        if (this.color(v) === this.color(current)) n += 12;
        return n;
      };
      return candidates.sort((a,b) => score(b)-score(a))[0];
    }
    group(title, field, values, selected) {
      const group = document.createElement('div');
      group.className = 'canvas-choice-group'; group.setAttribute('role','group'); group.setAttribute('aria-label',title);
      const label = document.createElement('p'); label.className = 'form__label'; label.textContent = title; group.append(label);
      const row = document.createElement('div'); row.className = 'canvas-choice-row'; group.append(row);
      if (field === 'model') { row.classList.add('frame-model-cards'); row.style.setProperty('--model-columns',values.length === 4 ? 2 : values.length); }
      values.forEach(({value,name},index) => {
        const variant = this.target(field,value);
        const button = document.createElement('button'); button.type = 'button'; button.className = 'canvas-choice';
        button.id = `canvas-${this.picker.dataset.section}-${field}-${index}`;
        button.dataset.field = field; button.dataset.value = value;
        button.setAttribute('aria-pressed',String(selected === value));
        button.disabled = !variant || !variant.available;
        if (field === 'model') {
          button.classList.add('canvas-choice--model');
          const color = value === 'gallery' ? 'Siyah' : this.color(this.selected);
          const src = this.images[value]?.[color] || this.images[value]?.Siyah;
          if (src) {
            const photo = document.createElement('span'); photo.className = 'frame-model-photo';
            if (value === 'canvas') photo.classList.add('frame-model-photo--canvas');
            const image = document.createElement('img'); image.src = src; image.alt = ''; image.width = 320; image.height = 320; image.decoding = 'async';
            photo.append(image); button.append(photo);
          }
        }
        if (field === 'color') {
          const dot = document.createElement('span'); dot.className = 'canvas-color-dot'; dot.dataset.color = value; dot.setAttribute('aria-hidden','true'); button.append(dot);
        }
        const text = document.createElement('span'); text.textContent = name; button.append(text);
        if (field === 'model') {
          const detail = document.createElement('span'); detail.className = 'frame-model-detail';
          detail.textContent = {standard:this.dataset.standardDetail,deep:this.dataset.deepDetail,gallery:this.dataset.galleryDetail,canvas:this.dataset.canvasDetail}[value] || ''; button.append(detail);
        }
        if (field === 'size') {
          const price = document.createElement('span'); price.className = 'canvas-price'; price.textContent = variant ? this.money(variant.price) : this.dataset.unavailable; button.append(price);
        }
        row.append(button);
      });
      return group;
    }
    render() {
      const model = this.model(this.selected);
      const modelNames = {standard:this.dataset.standardLabel, deep:this.dataset.deepLabel, gallery:this.dataset.galleryLabel, canvas:this.dataset.lLabel};
      const groups = this.querySelector('[data-canvas-groups]'); groups.replaceChildren();
      const models = ['standard','deep','gallery','canvas'].filter(m => this.variants.some(v => this.model(v) === m));
      groups.append(this.group(this.dataset.modelLabel,'model',models.map(m => ({value:m,name:modelNames[m]})),model));
      const note = {canvas:this.dataset.canvasNote, deep:this.dataset.deepNote, gallery:this.dataset.galleryNote}[model];
      if (note) { const helper = document.createElement('p'); helper.className = 'canvas-helper canvas-model-note'; helper.textContent = note; groups.append(helper); }
      const variants = this.variants.filter(v => this.model(v) === model);
      const colors = [...new Set(variants.map(v => this.color(v)))];
      groups.append(this.group(this.dataset.colorLabel,'color',colors.map(c => ({value:c,name:c})),this.color(this.selected)));
      const sizes = [...new Set(variants.map(v => v.options[this.sizeIndex]))];
      groups.append(this.group(this.dataset.sizeLabel,'size',sizes.map(s => ({value:s,name:s.replace('x',' × ')})),this.selected.options[this.sizeIndex]));
      if (model !== 'canvas' && this.styleIndex >= 0) {
        const styles = [...new Set(variants.map(v => v.options[this.styleIndex]))];
        if (styles.length > 1) groups.append(this.group(this.dataset.styleLabel,'style',styles.map(s => ({value:s,name:s})),this.selected.options[this.styleIndex]));
      }
      this.picker.querySelector('.canvas-native-options').hidden = true;
    }
    choose(event) {
      const button = event.target.closest('button');
      if (!button || button.disabled || this.getAttribute('aria-busy') === 'true') return;
      const variant = this.target(button.dataset.field,button.dataset.value);
      if (!variant || !variant.available || variant.id === this.selected.id) return;
      const ids = this.options.map((o,i) => o.values.find(v => v.name === variant.options[i])?.id);
      if (ids.some(id => !id)) return;
      this.setAttribute('aria-busy','true'); this.querySelector('.canvas-error').hidden = true;
      const info = this.closest('product-info');
      const requestUrl = info.buildRequestUrlWithParams(this.dataset.productUrl,ids,false);
      info.resetProductFormState(); info.abortController?.abort(); info.abortController = new AbortController();
      fetch(requestUrl,{signal:info.abortController.signal}).then(r => {
        if (!r.ok) throw new Error('variant request failed');
        return r.text();
      }).then(text => {
        const html = new DOMParser().parseFromString(text,'text/html');
        if (info.getSelectedVariant(html)?.id !== variant.id) throw new Error('variant mismatch');
        info.handleUpdateProductInfo(this.dataset.productUrl)(html);
        document.getElementById(button.id)?.focus({preventScroll:true});
      }).catch(error => {
        if (error.name === 'AbortError') return;
        this.removeAttribute('aria-busy'); this.querySelector('.canvas-error').hidden = false;
        info.productForm?.toggleSubmitButton(!this.selected.available,window.variantStrings.soldOut);
      });
    }
  });
}
